angular.module('bribac.components.subjectEditor', [
  'bribac.values',
  'bribac.entities.kinds',
  'bribac.entities.ruleSetFactory',
  'bribac.entities.schedulePeriodFactory',
  'bribac.entities.scheduleFactory',
  'bribac.entities.externalMonitorFactory',
  'bribac.services.api',
  'bribac.services.updateRuleSetReadFormat',
  'bribac.services.updateRuleSetEditFormat',
  'bribac.services.errorUtils',
  'bribac.components.whenLoaded',
  'bribac.components.ruleSetDetails',
  'bribac.components.insuranceDetails',
  'bribac.components.ruleSetEditor',
  'bribac.components.schedulePeriodEditor',
  'bribac.components.schedulePeriodDetails',
  'bribac.components.scheduleEditor',
  'bribac.components.inputFile',
  'bribac.components.externalMonitorDetails',
  'bribac.components.externalMonitorEditor',
  'bribac.components.insuranceDataEditor',
  'bribac.components.boostImage',
  'bribac.translations'
])

  .component('subjectEditor', {
    templateUrl: 'subject-editor-component.html',
    controller: 'SubjectEditorComponentCtrl',
    bindings: {
      subject: '<',
      successCallback: '<',
      organizationCanBeSpecified: '<'
    }
  })

  .controller('SubjectEditorComponentCtrl', function(
    $window,
    $translate,
    $scope,
    KINDS,
    PHONE_NUMBER_REGEX,
    SSN_REGEX,
    ruleSetFactory,
    schedulePeriodFactory,
    scheduleFactory,
    externalMonitorFactory,
    api,
    state,
    availableLocales,
    updateRuleSetReadFormat,
    updateRuleSetEditFormat,
    errorUtils,
    permissions,
    FLAVOUR,
    US_STATES
  ) {
    var $ctrl = this

    $ctrl.ibacs = []
    $ctrl.permissions = permissions
    $ctrl.PHONE_NUMBER_REGEX = PHONE_NUMBER_REGEX
    $ctrl.SSN_REGEX = SSN_REGEX
    $ctrl.availableLocales = Object.keys(availableLocales)
    $ctrl.assignableIbacs = []
    $ctrl.flavour = FLAVOUR
    $ctrl.stateOptions = US_STATES
    $ctrl.isSubjectSubscriber = false;

    function onFormSubmit($form, kind, data, successCallback) {
      if ($form._submitting) return
      if ($form.$invalid || !data.subGroup) {
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $form._submitting = true
      $form._submitError = ''

      if ($ctrl.ibacs !== undefined && $ctrl.ibacs.length > 0)
        data.ibac = $ctrl.ibacs[0]
      else
        data.ibac = null

      if (!data.insurance.policyNumber) {
        data.insurance = null;
      }

      api[data.id ? 'put' : 'post'](kind, data)
        .finally(function() {
          $form._submitting = false
        })
        .then(
          function success(request) {
            successCallback(request.data)
          },

          function error(request) {
            $form._submitError = errorUtils.parseErrorResponse(request)
          }
        )
    }

    function resetForm($form) {
      if ($form) {
        $form.$setUntouched()
        $form.$setPristine()
      }
    }

    function resetSubject() {
      resetForm($ctrl.subjectForm)
      $ctrl.scheduleSaveSuccess = ''
      $ctrl.editableSubject = angular.copy($ctrl.subject)

      if ($ctrl.editableSubject.ruleSet) {
        $ctrl.editableSubject.ruleSet = updateRuleSetEditFormat($ctrl.editableSubject.ruleSet)
      }

      if ($ctrl.editableSubject.insurance) {
        if ($ctrl.editableSubject.insurance.insuranceCompany) {
          $ctrl.editableSubject.insurance.insuranceCompanyId = $ctrl.editableSubject.insurance.insuranceCompany.id;
        }

        if ($ctrl.editableSubject.insurance.insuranceProvider) {
          $ctrl.editableSubject.insurance.insuranceProviderId = $ctrl.editableSubject.insurance.insuranceProvider.id;
        }

        if ($ctrl.editableSubject.insurance.insuranceSubscriber) {
          $ctrl.editableSubject.insurance.insuranceSubscriberId = $ctrl.editableSubject.insurance.insuranceSubscriber.id;
        }
      }

    }

    $ctrl.onDateOfBirthChange = function () {
      if (!$ctrl.editableSubject.dateOfBirth) return;

      // First check basic format with regex
      if (!$ctrl.editableSubject.dateOfBirth.match(/^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/)) {
        $ctrl.editableSubject.dateOfBirth = null;
        return;
      }

      // Then check if it's a valid date (e.g., not Feb 30 or Apr 31)
      const dateComponents = $ctrl.editableSubject.dateOfBirth.split('-');
      const year = parseInt(dateComponents[0], 10);
      const month = parseInt(dateComponents[1], 10);
      const day = parseInt(dateComponents[2], 10);

      // Create a date and check if it matches what was entered
      const date = new Date(year, month - 1, day); // JS months are 0-indexed

      if (date.getFullYear() !== year ||
          date.getMonth() + 1 !== month ||
          date.getDate() !== day) {
        // The date was invalid (e.g., Feb 30 would become March 2)
        $ctrl.editableSubject.dateOfBirth = null;
      }
    };

    $ctrl.onMainGroupChange = function() {
      $ctrl.editableSubject.subGroup = null
    }

    $ctrl.subjectSubmitDisabled = function() {
      return $ctrl.subjectForm._submitting
        || $ctrl.areAnyFormsOpen()
    }

    $ctrl.areAnyFormsOpen = function() {
      return $ctrl.isAnyRuleSetFormOpen()
        || $ctrl.isAnyScheduleFormOpen()
        || $ctrl.extMonitorFormIsOpen
    }

    $ctrl.onSubjectSubmit = function() {
      var $form = $ctrl.subjectForm
      $form._submitSuccess = ''

      // When this is called by a button outside of the form the $submitted
      // state is not set like it is when a normal form submit button is
      // clicked, so we have to set it ourselves.
      $form.$setSubmitted()

      $form.$setValidity('required', !!$ctrl.editableSubject.ruleSet, null)

      updateInsuranceSubscriberCommand();

      onFormSubmit(
        $form,
        KINDS.SUBJECT,
        $ctrl.editableSubject,
        function success(data) {
          $form._submitSuccess = $translate.instant('formSuccess.savedUser', {name: data.fullName, email: data.email })
          $ctrl.successCallback(data)
        }
      )
    }

    $ctrl.handleLoadedCompanies = function (companies) {
      $ctrl.insuranceCompany = companies;
    };

      $ctrl.handleLoadedProviders = function (providers) {
          $ctrl.insuranceProvider = providers;
      };

      $ctrl.handleLoadedSubscribers = function (subscribers) {
          $ctrl.insuranceSubscriber = subscribers;
      };

    function resetAddInsuranceForm() {
      $ctrl.addInsuranceFormIsOpen = false
      $ctrl.newInsurance = null
    }

    /*
    Add insurance
     */

    $ctrl.openAddInsuranceForm = function() {
      $ctrl.insuranceSaveSuccess = ''
      $ctrl.newInsurance = {
        "policyNumber": null,
        "groupNumber": null,
        "insuranceSubscriberId": null,
        "insuranceCompanyId": null,
        "subscriberRelation": null,
        "insuranceReferringProvider": null,
        "insuranceRenderingProvider": null,
        "insuranceProviderId": null
      }
      $ctrl.addInsuranceFormIsOpen = true
    }

    $ctrl.onAddInsuranceSuccess = function(newInsurance) {
      $ctrl.editableSubject.insurance = newInsurance

      const company = $ctrl.insuranceCompany.find(
          (company) => company.id === $ctrl.editableSubject.insurance.insuranceCompanyId
      );

      if (company) {
        $ctrl.editableSubject.insurance.insuranceCompany = company;
      }

      const provider = $ctrl.insuranceProvider.find(
          (provider) => provider.id === $ctrl.editableSubject.insurance.insuranceProviderId
      );

      if (provider) {
        $ctrl.editableSubject.insurance.insuranceProvider = provider;
      }

      const subscriber = $ctrl.insuranceSubscriber.find(
          (subscriber) => subscriber.id === $ctrl.editableSubject.insurance.insuranceSubscriberId
      );

      if (subscriber) {
        $ctrl.editableSubject.insurance.insuranceSubscriber = subscriber;
      }

      resetAddInsuranceForm()
    }

    $ctrl.onAddInsuranceCancel = resetAddInsuranceForm

    $ctrl.initializeInsuranceData = function () {
      $ctrl.editableSubject.insurance = {};
    };

    $ctrl.openEditAppliedInsuranceForm = function () {
      $ctrl.insuranceSaveSuccess = ''
      $ctrl.insuranceOpenForEditing = $ctrl.editableSubject.insurance
      $ctrl.editAppliedInsuranceFormIsOpen = true
    };

    $ctrl.cancelInsuranceForm = function () {
      $ctrl.isInsuranceFormOpen = false;
    };

    $ctrl.removeAppliedInsurance = function() {
      var answer = $window.confirm('Do you really want to remove the insurance for subject?')
      if (answer) {
        $ctrl.editableSubject.insurance = null
      }
    }

    $ctrl.onEditAppliedInsuranceSuccess = function(updatedInsurance) {
      const updatedCompany = $ctrl.insuranceCompany.find(
          (company) => company.id === updatedInsurance.insuranceCompanyId
      );

      if (updatedCompany) {
        updatedInsurance.insuranceCompany = updatedCompany;
      }

        const updatedProvider = $ctrl.insuranceProvider.find(
            (provider) => provider.id === updatedInsurance.insuranceProviderId
        );

        if (updatedProvider) {
            updatedInsurance.insuranceProvider = updatedProvider;
        }

      const updatedSubscriber = $ctrl.insuranceSubscriber.find(
          (subscriber) => subscriber.id === updatedInsurance.insuranceSubscriberId
      );

      if (updatedSubscriber) {
        updatedInsurance.insuranceSubscriber = updatedSubscriber;
      }

      $ctrl.editableSubject.insurance = angular.copy(updatedInsurance);
      resetEditAppliedInsuranceForm()
    }

    function resetEditAppliedInsuranceForm() {
      $ctrl.editAppliedInsuranceFormIsOpen = false
      $ctrl.insuranceOpenForEditing = null
    }

    $ctrl.onEditAppliedInsuranceCancel = resetEditAppliedInsuranceForm

    function updateInsuranceSubscriberCommand() {
      if (!$ctrl.editableSubject.insurance) {
        $ctrl.editableSubject.insurance = {};
      }

      $ctrl.editableSubject.insurance.subscriberRelation = 'self'

      $ctrl.editableSubject.insurance.insuranceSubscriberCommand = {
        firstName: $ctrl.editableSubject.firstName || '',
        lastName: $ctrl.editableSubject.lastName || '',
        streetAddress: [$ctrl.editableSubject.address, $ctrl.editableSubject.address2].filter(Boolean).join(' '),
        city: $ctrl.editableSubject.city || '',
        state: $ctrl.editableSubject.state || '',
        zip: $ctrl.editableSubject.postalCode || '',
        gender: $ctrl.editableSubject.gender || '',
        mainGroupsIds: $ctrl.mainGroup ? [$ctrl.mainGroup.id] : [],
        dateOfBirth: $ctrl.editableSubject.dateOfBirth
            ? $ctrl.editableSubject.dateOfBirth
            : null
      };
    }

    $ctrl.updateSubscriberStatus = function(value) {
      $ctrl.isSubjectSubscriber = value;

      updateInsuranceSubscriberCommand();
    };

    /*
      Rule-set/settings
    */

    $ctrl.isAnyRuleSetFormOpen = function() {
      return $ctrl.addNewRuleSetFormIsOpen
        || $ctrl.addRuleSetTemplateFormIsOpen
        || $ctrl.editAppliedRuleSetFormIsOpen
    }


    /*
      Add new rule-set/settings
    */

    function resetAddNewRuleSetForm() {
      $ctrl.addNewRuleSetFormIsOpen = false
      $ctrl.newRuleSet = null
    }

    $ctrl.openAddNewRuleSetForm = function() {
      $ctrl.ruleSetSaveSuccess = ''
      $ctrl.newRuleSet = ruleSetFactory({
        bacLimit: {
          unit: state.currentAgent.organization.bacUnit
        }
      })
      $ctrl.addNewRuleSetFormIsOpen = true
    }

    $ctrl.onAddNewRuleSetSuccess = function(newRuleSet) {
      $ctrl.editableSubject.ruleSet = updateRuleSetReadFormat(newRuleSet)
      resetAddNewRuleSetForm()
    }

    $ctrl.onAddNewRuleSetCancel = resetAddNewRuleSetForm


    /*
      Add rule-set/settings from template
    */

    function resetAddRuleSetTemplateForm() {
      $ctrl.addRuleSetTemplateFormIsOpen = false
      $ctrl.selectedRuleSetTemplate = null
    }

    $ctrl.openAddRuleSetTemplateForm = function() {
      $ctrl.ruleSetSaveSuccess = ''
      $ctrl.ruleSetsPromise = api.get(KINDS.RULE_SET).then(function(request) {
        $ctrl.ruleSets = request.data.list
      })
      $ctrl.addRuleSetTemplateFormIsOpen = true
    }

    $ctrl.onAddRuleSetTemplateSuccess = function() {
      // The applied template should not be saved as a new template when the
      // subject is saved.
      $ctrl.selectedRuleSetTemplate.template = false
      $ctrl.editableSubject.ruleSet = updateRuleSetEditFormat($ctrl.selectedRuleSetTemplate)
      resetAddRuleSetTemplateForm()
    }

    $ctrl.onAddRuleSetTemplateCancel = resetAddRuleSetTemplateForm


    /*
      Edit applied rule-set/settings
    */

    function resetEditAppliedRuleSetForm() {
      $ctrl.editAppliedRuleSetFormIsOpen = false
      $ctrl.ruleSetOpenForEditing = null
    }

    $ctrl.openEditAppliedRuleSetForm = function() {
      $ctrl.ruleSetSaveSuccess = ''
      $ctrl.ruleSetOpenForEditing = updateRuleSetEditFormat($ctrl.editableSubject.ruleSet)
      $ctrl.editAppliedRuleSetFormIsOpen = true
    }

    $ctrl.onEditAppliedRuleSetSuccess = function(updatedRuleSet) {
      $ctrl.editableSubject.ruleSet = updateRuleSetReadFormat(updatedRuleSet)
      resetEditAppliedRuleSetForm()
    }

    $ctrl.onEditAppliedRuleSetCancel = resetEditAppliedRuleSetForm


    /*
      Remove applied rule-set/settings
    */

    $ctrl.removeAppliedRuleSet = function() {
      var answer = $window.confirm('Do you really want to remove these ibac settings from the subject?')
      if (answer) {
        $ctrl.editableSubject.ruleSet = null
      }
    }


    /*
      Schedule (and Schedule Period)
    */

    $ctrl.isAnyScheduleFormOpen = function() {
      return $ctrl.addNewScheduleFormIsOpen
        || $ctrl.addScheduleTemplateFormIsOpen
        || $ctrl.editAppliedScheduleFormIsOpen
    }


    /*
      Add new schedule
    */

    function resetAddNewScheduleForm() {
      $ctrl.addNewScheduleFormIsOpen = false
      $ctrl.newSchedulePeriod = null
    }

    $ctrl.openAddNewScheduleForm = function() {
      $ctrl.scheduleSaveSuccess = ''
      $ctrl.newSchedulePeriod = schedulePeriodFactory({
        // Set ID so it works with ng-repeat.
        id: 'TEMPORARY_' + Math.random(),
        schedule: scheduleFactory()
      })
      $ctrl.addNewScheduleFormIsOpen = true
    }

    $ctrl.onAddNewScheduleSuccess = function(newSchedulePeriod) {
      $ctrl.editableSubject.schedulePeriods.push(newSchedulePeriod)
      resetAddNewScheduleForm()
    }

    $ctrl.onAddNewScheduleCancel = resetAddNewScheduleForm


    /*
      Add schedule from template
    */

    function resetAddScheduleTemplateForm() {
      $ctrl.addScheduleTemplateFormIsOpen = false
      $ctrl.newSchedulePeriod = null
    }

    $ctrl.openAddScheduleTemplateForm = function() {
      $ctrl.scheduleSaveSuccess = ''
      $ctrl.newSchedulePeriod = schedulePeriodFactory({
        // Set ID so it works with ng-repeat.
        id: 'TEMPORARY_' + Math.random()
      })
      $ctrl.addScheduleTemplateFormIsOpen = true
    }

    $ctrl.onAddScheduleTemplateSuccess = function(newSchedulePeriod) {
      // The applied template should not be saved as a new template when the
      // subject is saved.
      newSchedulePeriod.schedule.template = false
      $ctrl.editableSubject.schedulePeriods.push(newSchedulePeriod)
      resetAddScheduleTemplateForm()
    }

    $ctrl.onAddScheduleTemplateCancel = resetAddScheduleTemplateForm


    /*
      Remove applied schedule
    */

    $ctrl.removeAppliedSchedulePeriod = function(schedulePeriodToRemove) {
      var now = new Date()
      var startDate = new Date(schedulePeriodToRemove.startDate)
      var endDate = new Date(schedulePeriodToRemove.endDate)
      var toDelete = $window.confirm($translate.instant('components.schedulePeriodEditor.question.deleteSchedule', null, "", "", ""))
      schedulePeriodToRemove.toDelete = toDelete
      if (startDate.getTime() <= now.getTime() && endDate.getTime() >= now.getTime() && toDelete) {
        var reschedule = $window.confirm($translate.instant('components.schedulePeriodEditor.question.deleteTests', null, "", "", ""))
        schedulePeriodToRemove.reschedule = reschedule
      }
    }


    /*
      Edit applied schedule
    */

    function resetEditAppliedScheduleForm() {
      $ctrl.editAppliedScheduleFormIsOpen = false
      $ctrl.schedulePeriodOpenForEditing = null
    }

    $ctrl.openEditAppliedScheduleForm = function(schedulePeriod) {
      $ctrl.scheduleSaveSuccess = ''
      $ctrl.schedulePeriodOpenForEditing = schedulePeriod
      $ctrl.editAppliedScheduleFormIsOpen = true
    }

    $ctrl.onEditAppliedScheduleSuccess = function(updatedSchedulePeriod) {
      $ctrl.scheduleSaveSuccess = 'The schedule was updated'
      $ctrl.editableSubject.schedulePeriods = $ctrl.editableSubject.schedulePeriods.map(function(schedulePeriod) {
        if (schedulePeriod.id === updatedSchedulePeriod.id) {
          return updatedSchedulePeriod
        }
        return schedulePeriod
      })
      resetEditAppliedScheduleForm()
    }

    $ctrl.onEditAppliedScheduleCancel = resetEditAppliedScheduleForm


    $scope.handleFileRead = function (content) {
      const csvMapping = getCsvMapping();
      const valuesMap = parseCsvContent(content);
      const fieldValues = createFieldValues(valuesMap, csvMapping);

      updateEditableSubject(fieldValues);

      const ibacFromCsv = fieldValues.get("ibacMac");
      const foundInList = findIbacInList(ibacFromCsv);

      if (foundInList) {
        updateIbacSelection(foundInList);
      }

      populateRuleSet(fieldValues);
      populateSchedules(fieldValues);
      populateExternalMonitors(fieldValues);
    };

    $ctrl.onPhotoAdded = function(e, fileObjects, fileList) {

      // To prevent showing alert multiple times, this variable will store if image count exceeds the defined max count(i.e 5)
      var imageCountExceeds = false
      fileObjects.forEach(function(file) {
        $ctrl.photoSize = $ctrl.editableSubject.photos.filter(function(photo) {
            return (photo.toDelete == null || photo.toDelete == false)
        })
        if($ctrl.photoSize.length < 5) {
            imageCountExceeds = false
            $ctrl.editableSubject.photos.push(file)
        } else {
            imageCountExceeds = true
        }
      })
      if (imageCountExceeds) {
        alert($translate.instant('components.subjectEditor.alertSelectOnlyFiveImages'));
      }

    }

    $ctrl.deletePhoto = function(photo) {
      if (photo.base64) {
        var index = $ctrl.editableSubject.photos.indexOf(photo);
        $ctrl.editableSubject.photos.splice(index, 1)
      } else {
        photo.toDelete = true
      }
    }

    /*
      External monitors
    */

    $ctrl.openAddNewExtMonitorForm = function() {
      $ctrl.extMonitorOpenForEditing = externalMonitorFactory({
        // Set ID so it works with ng-repeat.
        id: 'TEMPORARY_' + Math.random(),
      })
      $ctrl.extMonitorFormIsOpen = true
    }

    $ctrl.onAddNewExtMonitorSuccess = function(newExtMonitor) {
      var monitor =  $ctrl.editableSubject.externalMonitors.filter(function(it) {
        return it.id === newExtMonitor.id
      })[0]
      if (monitor) {
        monitor.name = newExtMonitor.name
        monitor.phone = newExtMonitor.phone
        monitor.email = newExtMonitor.email
      } else {
        $ctrl.editableSubject.externalMonitors.push(newExtMonitor)
      }

      resetAddExtMonitorForm()
    }

    $ctrl.openEditExtMonitorForm = function(extMonitor) {
      $ctrl.extMonitorOpenForEditing = extMonitor
      $ctrl.extMonitorFormIsOpen = true
      $ctrl.extMonitorIsBeingEdited = true
    }

    function resetAddExtMonitorForm() {
      $ctrl.extMonitorFormIsOpen = false
      $ctrl.newExtMonitor = null
      $ctrl.extMonitorIsBeingEdited = false
    }

    $ctrl.onAddNewExtMonitorCancel = resetAddExtMonitorForm

    $ctrl.removeExternalMonitor = function(extMonitorToRemove) {
      var answer = $window.confirm($translate.instant('components.subjectEditor.deleteExtMonitorQuestion',
          null, "", "", ""))
      if (answer) {
        $ctrl.editableSubject.externalMonitors = $ctrl.editableSubject.externalMonitors.filter(function(extMonitor) {
          return extMonitor.id !== extMonitorToRemove.id
        })
      }
    }

    /*
      Init
    */

    $ctrl.$onChanges = function(changes) {
      if (changes.subject) {
        resetSubject()
      }
    }

    $ctrl.datePickerOpen = {
      dateOfBirth: false,
    };

    $ctrl.datePickerOptions = {
      maxDate: new Date(),
      startingDay: 1,
    };

    $ctrl.toggleDatePicker = function (field) {
      $ctrl.datePickerOpen[field] = !$ctrl.datePickerOpen[field];
    };

    function reload() {
      var filter = ''

      if ($ctrl.permissions.canManageOrganizations()) {
        if (!$ctrl.editableSubject.organization) {
          return
        } else {
          filter = '?organization=' + $ctrl.editableSubject.organization.id
        }
      }

      $ctrl.mainGroupsPromise = api.getFilteredByOrg(KINDS.MAIN_GROUP, filter).then(function(request) {
        $ctrl.mainGroups = request.data.list

        var currentSubGroup = $ctrl.editableSubject.subGroup
        if (currentSubGroup) {
          // Restore group selection.
          $ctrl.mainGroup = $ctrl.mainGroups.filter(function(mainGroup) {
            return mainGroup.id === currentSubGroup.mainGroup.id
          })[0]
          // We need to use the sub group on the main group returned by the
          // main groups promise since that is what's used to list the groups in
          // the template, otherwise the ng-model won't match and the sub group
          // selection won't be restored when editing a subject.
          if ($ctrl.mainGroup) {
            $ctrl.editableSubject.subGroup = $ctrl.mainGroup.subGroups.filter(function (subGroup) {
              return subGroup.id === currentSubGroup.id
            })[0]
          } else {
            // Main group was not found => organization was changed
            $ctrl.editableSubject.subGroup = null
          }
        }
      })

      $ctrl.agentsPromise = api.getFilteredByOrg(KINDS.AGENT, filter).then(function(request) {
        $ctrl.agents = request.data.list
      })

      $ctrl.assignableIbacsPromise = api.getFilteredByOrg(KINDS.ASSIGNABLE_IBACS, filter).then(function(request) {
        $ctrl.assignableIbacs = request.data
        // Put currently selected iBac on first place in array. Otherwise it will not be shown
        // because this request returns only unassigned iBacs.
        if ($ctrl.editableSubject.ibac && $ctrl.assignableIbacs) {
          $ctrl.assignableIbacs.unshift($ctrl.editableSubject.ibac)
          $ctrl.ibacs = [$ctrl.editableSubject.ibac]
        }
      })
    }

    function getCsvMapping() {
      return {
        "first_name": "firstName",
        "last_name": "lastName",
        "ssn": "ssn",
        "email": "email",
        "phone": "phone",
        "postal_code": "postalCode",
        "street": "address",
        "city": "city",
        "device_serial_number": "ibacMac",
        "gps_required": "requireGpsLocation",
        "alcohol_limit": "bacLimit",
        "notify_client_using": "notifySubjectBy",
        "test_expires_after": "testExpiresAfterSeconds",
        "notify_monitors_when": "notifyMonitorsWhen",
        "allow_client_to_see_results": "showResults",
        "selected_days": "weekdays",
        "selected_times": "fixedTimes",
        "first_name_monitor_1": "firstNameMonitor1",
        "last_name_monitor_1": "lastNameMonitor1",
        "notify_monitor_1_by_email_or_text": "notifyMonitor1ByEmailOrText",
        "first_name_monitor_2": "firstNameMonitor2",
        "notify_monitor_2_by_email_or_text": "notifyMonitor2ByEmailOrText",
        "last_name_monitor_2": "lastNameMonitor2",
        "first_name_monitor_3": "firstNameMonitor3",
        "last_name_monitor_3": "lastNameMonitor3",
        "notify_monitor_3_by_email_or_text": "notifyMonitor3ByEmailOrText"
      };
    }

    function parseCsvContent(content) {
      const csvArray = content.split('\n');
      const header = csvArray[0].split(',');
      const csvValues = csvArray[1].split(',')
      const valuesMap = new Map();

      for (let i = 0; i < header.length; i++) {
        valuesMap.set(header[i], csvValues[i]);
      }
      return valuesMap;
    }

    function createFieldValues(valuesMap, csvMapping) {
      const fieldValues = new Map();

      valuesMap.forEach((value, key) => {
        const sanitizedKey = key.trim().replace(/[\r]+/g, '');
        fieldValues.set((csvMapping[sanitizedKey] || sanitizedKey), value);
      });

      return fieldValues;
    }

    function updateEditableSubject(fieldValues) {
      fieldValues.forEach((value, key) => {
        $scope.$ctrl.editableSubject[key] = value;
      });
    }

    function findIbacInList(ibacMac) {
      return $scope.$ctrl.assignableIbacs.find(item => item.macAddress === ibacMac);
    }

    function updateIbacSelection(foundInList) {
      $scope.$ctrl.assignableIbacs = [...$scope.$ctrl.assignableIbacs, ...$scope.$ctrl.ibacs];
      $scope.$ctrl.ibacs = [foundInList];
    }

    function populateRuleSet(fieldValues) {
      const notifyMonitorsMapping = {
        "testFailed": "notifyFailed",
        "testPassed": "notifyPassed",
        "optionalTestPassed": "notifyPassedOptional",
        "optionalTestFailed": "notifyFailedOptional",
        "testExpired": "notifyExpired",
      }

      const notifySubjectsByMapping = {
        "sms": "notifySubjectBySms",
        "email": "notifySubjectByMail",
        "push": "notifySubjectByPush"
      }

      $ctrl.openAddNewRuleSetForm();

      $ctrl.newRuleSet.bacLimit.value = parseFloat(fieldValues.get("bacLimit") || "0")
      $ctrl.newRuleSet.requireGpsLocation = Boolean(fieldValues.get("requireGpsLocation") || false);
      $ctrl.newRuleSet.testExpiresAfterSeconds = Number(fieldValues.get("testExpiresAfterSeconds") || 0);
      $ctrl.newRuleSet.showResults = Boolean(fieldValues.get("showResults") || false);
      $ctrl.newRuleSet.deleteTestDataAfterDays = Number(fieldValues.get("deleteTestDataAfterDays") || null);

      fieldValues.get("notifyMonitorsWhen")
          .split(";")
          .map(value => {
            return notifyMonitorsMapping[value] || null;
          })
          .forEach((key) => {
            $ctrl.newRuleSet[key] = true
          });

      fieldValues.get("notifySubjectBy")
          .split(";")
          .map(value => {
            return notifySubjectsByMapping[value] || null;
          })
          .forEach((key) => {
            $ctrl.newRuleSet[key] = true
          });

      $ctrl.onAddNewRuleSetSuccess($ctrl.newRuleSet);
    }

    function populateSchedules(fieldValues) {
      const daysMap = {
        "Monday": "MON",
        "Tuesday": "TUE",
        "Wednesday": "WED",
        "Thursday": "THU",
        "Friday": "FRI",
        "Saturday": "SAT",
        "Sunday": "SUN"
      }

      if (fieldValues.get("weekdays") && fieldValues.get("fixedTimes")) {
        $ctrl.openAddNewScheduleForm();
        $ctrl.newSchedulePeriod.schedule.weekdays = fieldValues.get("weekdays")
                .split(";")
                .map(day => daysMap[day]);

        $ctrl.newSchedulePeriod.schedule.fixedTimes = fieldValues.get("fixedTimes")
                .split(";")
                .map(time => ({time}));
      }
    }

    function populateExternalMonitors(fieldValues) {
      if (fieldValues.get("firstNameMonitor1")) {
        $ctrl.openAddNewExtMonitorForm()

        $ctrl.extMonitorOpenForEditing.name = fieldValues.get("firstNameMonitor1") + " " + fieldValues.get("lastNameMonitor1")

        if (fieldValues.get("notifyMonitor1ByEmailOrText")) {
          const contact = fieldValues.get("notifyMonitor1ByEmailOrText");

          if (PHONE_NUMBER_REGEX.test(contact)) {
            $ctrl.extMonitorOpenForEditing.phone = contact;
          } else {
            $ctrl.extMonitorOpenForEditing.email = contact;
          }

        }

        $ctrl.onAddNewExtMonitorSuccess($ctrl.extMonitorOpenForEditing)
      }

      if (fieldValues.get("firstNameMonitor2")) {
        $ctrl.openAddNewExtMonitorForm()

        $ctrl.extMonitorOpenForEditing.name = fieldValues.get("firstNameMonitor2") + " " + fieldValues.get("lastNameMonitor2")

        if (fieldValues.get("notifyMonitor2ByEmailOrText")) {
          const contact = fieldValues.get("notifyMonitor2ByEmailOrText");

          if (PHONE_NUMBER_REGEX.test(contact)) {
            $ctrl.extMonitorOpenForEditing.phone = contact;
          } else {
            $ctrl.extMonitorOpenForEditing.email = contact;
          }

        }

        $ctrl.onAddNewExtMonitorSuccess($ctrl.extMonitorOpenForEditing);
      }

      if (fieldValues.get("firstNameMonitor3")) {
        $ctrl.openAddNewExtMonitorForm()

        $ctrl.extMonitorOpenForEditing.name = fieldValues.get("firstNameMonitor3") + " " + fieldValues.get("lastNameMonitor3")

        if (fieldValues.get("notifyMonitor3ByEmailOrText")) {
          const contact = fieldValues.get("notifyMonitor3ByEmailOrText");

          if (PHONE_NUMBER_REGEX.test(contact)) {
            $ctrl.extMonitorOpenForEditing.phone = contact;
          } else {
            $ctrl.extMonitorOpenForEditing.email = contact;
          }

        }

        $ctrl.onAddNewExtMonitorSuccess($ctrl.extMonitorOpenForEditing);
      }
    }

    $scope.$watch('$ctrl.editableSubject.organization', reload)

  })
